/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentHistory {
    getFixupPrototypeFunction() { return AssessmentHistory.fixupPrototype; }

    static newInstance(model: Partial<AssessmentHistory>): AssessmentHistory {
        let obj = Object.assign(new AssessmentHistory(), model);
        AssessmentHistory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentHistory>): AssessmentHistory {
        if (!model) return null;
        return AssessmentHistory.newInstance(<AssessmentHistory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentHistory) {
        if (!obj) return;

        models.AssessmentHistory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentHistory): boolean {
        Object.setPrototypeOf(obj, AssessmentHistory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.assessment_summary) {
            models.AssessmentSummaryData.fixupPrototype(this.assessment_summary);
        }
    }

    /**
     * URI of compliance standard
     */
    compliance_uri: string;

    /**
     * Unique Assessment job number of assessment triggered
     */
    assessment_job_number: string;

    /**
     * Id of tenant
     */
    tenant_id: string;

    /**
     * When was the assessment trigger created
     */
    created_at: Date;

    /**
     * Name of the user who triggered assessment
     */
    created_by: string;

    /**
     * When was the assessment trigger updated
     */
    updated_at: Date;

    /**
     * Name of the user who triggered assessment
     */
    updated_by: string;

    /**
     * Id of service account
     */
    service_account_id: string;

    /**
     * Status of assessment trigger
     */
    assessment_status: models.AssessmentStatus;

    /**
     * Whether all audit trails processed
     */
    all_trails_processed: boolean;

    /**
     * Type of execution.
     */
    execution_type: models.AssessmentExecutionType;

    /**
     * Summary of Assessment
     */
    assessment_summary: models.AssessmentSummaryData;

    /**
     * Archive status
     */
    is_archive: boolean;

    /**
     * Name of compliance standard
     */
    compliance_name: string;

    /**
     * Name of Service account
     */
    service_account_name: string;

}
